module.exports = {
    store: {
        en: "store",
        fi: "kauppa"
    },
    moreContacts: {
        en: "More contacts",
        fi: "Lisää yhteystietoja"
    },
    reviews: {
        en: "Reviews",
        fi: "Arvostelut"
    },
    rating: {
        en: "Rating",
        fi: "Arvostelu"
    },
    reviewText: {
        en: "Review text",
        fi: "Arvosteluteksti"
    },
    reviewTextPlaceholder: {
        en: "Review text here",
        fi: "Arvosteluteksti tänne"
    },
    submit: {
        en: "Submit",
        fi: "Lähetä"
    },
    loginToSubmitReview: {
        en: "Login to submit review",
        fi: "Kirjaudu lähettääksesi arvostelun"
    },
    noReview: {
        en: "No review",
        fi: "Ei arvosteluja"
    },
    serverError: {
        en: "Error! Server error.",
        fi: "Virhe! Serverivirhe."
    },
    searchPosts: {
        en: "Search posts",
        fi: "Etsi ilmoituksia"
    },
    noPostFound: {
        en: "No post found",
        fi: "Ei ilmoituksia"
    }
};